import { FORGET_PASSWORD } from "./constants";

export function forgetPassword(payload, onSuccessAlert) {
  return {
    type: FORGET_PASSWORD,
    payload,
    onSuccessAlert,
  };
}
